<article class="container">
  <header class="header">
    <h2 class="header__heading">Hello {{data.currentAccount.firstName}}!</h2>
    <p>
      You are just a few moments away from accessing your business financing.
      Once you get started, avoid closing your browser, hitting the refresh button, or leaving the screen before proceeding to the next step.
    </p>
  </header>
  <mat-divider></mat-divider>
  <section class="content">
    <h3 class="content__heading">What happens next?</h3>
    <section class="item">
      <img src="../../../../assets/img/checkout/verify.png"
           alt="Verify identity" />
      <div class="item__content">
        <div class="item__header">
          Verify your identity
        </div>
        <div *ngIf="checkoutState?.method === IdentityVerificationMethod.KBA">
          To make it easy and safe for you to verify your identity, we'll provide you with a few questions only {{data.currentAccount.firstName}} {{data.currentAccount.lastName}} will know the answers to.
        </div>
        <div *ngIf="checkoutState?.method === IdentityVerificationMethod.IDVerse">
          For your security, we'll verify your identity with an online document scan and a quick face check. This helps prevent fraud and makes sure only you can access your account.
        </div>
      </div>
    </section>

    <section class="item">
      <img src="../../../../assets/img/checkout/agreement.png"
           alt="Review agreement" />
      <div class="item__content">
        <span class="item__header">
          Review and accept the agreement
        </span>
        <span>
          We'll provide you with your terms and conditions.
        </span>
      </div>
    </section>

    <section class="item"
             *ngIf="data.loan?.productCode === productCodes.LOC || data.loan?.productCode === productCodes.Law">
      <img src="../../../../assets/img/checkout/funds.png"
           alt="Draw funds" />
      <div class="item__content">
        <span class="item__header">
          Draw funds
        </span>
        <span>
          Once you sign your agreement you'll be ready to draw funds from your line of credit.
        </span>
      </div>
    </section>

    <section class="item"
             *ngIf="data.loan?.productCode === productCodes.Term">
      <img src="../../../../assets/img/checkout/funds.png"
           alt="Get funded" />
      <div class="item__content">
        <span class="item__header">
          Get funded
        </span>
        <span>
          Once you sign your agreement we’ll disburse the funds into your bank account.
        </span>
      </div>
    </section>

    <section class="item">
      <img src="../../../../assets/img/checkout/link.png"
           alt="Link bank" />
      <div class="item__content">
        <span class="item__header">
          Link your bank
        </span>
        <span>
          After you submit your request, link your bank if you have not already done so.
          Linking your bank speeds up the funding process.
        </span>
      </div>
    </section>
  </section>

  <footer class="actions">
    <button mat-flat-button
            color="primary"
            (click)="continue()"
            [disabled]="!continueEnabled">Continue</button>
  </footer>
</article>
